<ion-app *ngIf="!scanning && !onMaintenanceApp">
	<ion-router-outlet></ion-router-outlet>
	<div *ngIf="loader()" class="loader-container">
		<div class="loader-main" [style.width]="'60px'" [style.height]="'60px'"></div>
	</div>
</ion-app>

<div *ngIf="scanning" style="position: absolute; top: 20px; right: 20px">
	<ion-icon
		(click)="stopScan()"
		style="position: absolute; top: 20px; right: 20px; font-size: 30px; cursor: pointer; z-index: 99999999"
		color="danger"
		name="close"
	>
	</ion-icon>
</div>

<div class="logo-container" *ngIf="progressBar && currentEvent">
	<div
		style="
			position: relative;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		"
	>
		<img *ngIf="logo" class="logo" [src]="logo" />
		<ion-progress-bar style="margin-top: 20px" [value]="initProgress"></ion-progress-bar>
	</div>
</div>

@if (SUtility.showAlertModal()) {
	<div
		class="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-[rgba(0,0,0,0.5)] tw-flex tw-flex-row tw-items-center tw-justify-center"
	>
		<div
			class="tw-min-w-[300px] tw-max-w-[80vw] tw-h-auto tw-bg-white tw-flex tw-flex-col tw-items-start tw-justify-start tw-rounded-lg"
		>
			<div
				style="border-bottom: 1px solid #e0e0e0"
				class="tw-w-full tw-h-[56px] tw-bg-white tw-rounded-t-lg tw-flex tw-flex-row tw-items-center tw-justify-between tw-px-[20px] tw-py-[10px] tw-font-bold"
			>
				{{ SUtility.alertModalTitle() }}
			</div>
			<div
				class="tw-w-full tw-h-auto tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-[20px]"
				[innerHTML]="SUtility.alertModalMessage() | safeHtml: 'html'"
			></div>

			<div
				style="border-top: 1px solid #e0e0e0"
				class="tw-w-full tw-h-[56px] tw-bg-white tw-rounded-b-lg tw-flex tw-flex-row tw-items-center tw-justify-end tw-px-[20px] tw-py-[10px]"
			>
				<div
					class="tw-text-sm tw-text-gray-500 tw-uppercase tw-font-bold tw-cursor-pointer"
					(click)="
						SUtility.showAlertModal.set(false);
						SUtility.alertModalTitle.set('');
						SUtility.alertModalMessage.set('')
					"
				>
					{{ "buttons.close" | translate }}
				</div>
			</div>
		</div>
	</div>
}

<div
	*ngIf="onMaintenanceApp"
	style="
		position: fixed;
		z-index: 9999999999;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: white;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	"
>
	<div
		style="
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 400px;
			height: auto;
			padding: 20px;
		"
	>
		<img style="width: 250px; height: auto; object-fit: cover; margin-bottom: 20px" [src]="logoPlatform" />
		<div style="font-weight: bold; font-size: x-large; text-align: center; width: 100%" class="tw-text-black">
			{{ "labels.on-maintenance" | translate }}
		</div>
	</div>
</div>
